
# ==============================================================================
# マウスオーバー処理
# ==============================================================================
imgMouseOverOut = (e)->
	if e.type is 'mouseover'
		reg   = /\/*.(jpg|jpeg|gif|png)$/
		rpd   = '--over.$1'
		$this = $(this)
		src   = $this.attr('src').replace(reg,rpd)
		$this.attr('src',src)
	else if e.type is 'mouseout'
		reg   = /\/*--over.(jpg|jpeg|gif|png)$/
		rpd   = '.$1'
		$this = $(this)
		src   = $this.attr('src').replace(reg,rpd)
		$this.attr('src',src)
	return

# ==============================================================================
# バナーの設定
# ==============================================================================
bannerSetting = ->
	$overs = $('.module__banner-set li.over img')
	$overs.on(
		'mouseover' : imgMouseOverOut
		'mouseout'  : imgMouseOverOut
	)
	return

# ==============================================================================
# パネルの設定
# ==============================================================================
panelSetting = ->
	$panelBanner     = $('.module__panel-banner')
	# --------------------------------------------------------------------------
	# スライダーパネル
	# --------------------------------------------------------------------------
	$sliderPanels = $('li.slider ul',$panelBanner)
	for sliderPanel in $sliderPanels
		$sliderPanel = $(sliderPanel)
		if 1 < $('li',sliderPanel).length
			$sliderPanel.bxSlider(
				captions   : false
				Carousel   : false
				controls   : true
				pager      : false
				auto       : true
				responsive : false
				mode       : 'fade'
			)
	# --------------------------------------------------------------------------
	# ティッカーパネル
	# --------------------------------------------------------------------------
	$tickerPanels       = $('li.ticker')
	$tickerPanels.on(
		'mouseover' : (e)->
			$('div.tick',this).css('display','block')
			return
		'mouseout' : (e)->
			$('div.tick',this).css('display','none')
			return
	)
	# --------------------------------------------------------------------------
	# マウスオーバーパネル
	# --------------------------------------------------------------------------
	$mouseOverPanels = $('li.over img',$panelBanner)
	$mouseOverPanels.on(
		'mouseover' : imgMouseOverOut
		'mouseout'  : imgMouseOverOut
	)
	return

# ==============================================================================
# でかいスライダーの設定
# ==============================================================================
# でかいスライダーが1ページに複数ある場合は対応していない
bigSliderSetting = ->
	threshold        = 6
	thumbHeight      = 60
	$bigSlider       = $('.module__big-slider')
	$controllerSet   = $('.controller',$bigSlider)
	$visSet          = $('.vis',$bigSlider)
	$topArrow        = $('.top',$controllerSet)
	$bottomArrow     = $('.bottom',$controllerSet)
	$thumbSet        = $('ul.thumb',$controllerSet)
	$thumbnail       = $('li img',$thumbSet)
	thumbNum         = $thumbnail.length
	thumbnailsOver   = if(thumbNum > threshold) then true else false
	slideTimer       = false
	autoSlideTime    = 5000
	$activeThumbnail = false
	$activeImg       = false
	fire             = false
	# disable          = false # スライダーにマウスが乗っている時にfalse
	forceDisable     = false # サムネイルをクリックしたときにtrue
	# --------------------------------------------------------------------------
	# 画像を切り替える処理：サムネイルが溢れていてもいなくても同じ処理
	# --------------------------------------------------------------------------
	changeImg = (name)->
		fire    = true
		$target = $('li[data-name='+name+']',$visSet)
		if $activeImg
			$activeImg.velocity('stop').velocity({
				opacity : 0
			},{
				duration : 500
				display  : 'none'
			})
		$activeImg = $target
		$target.velocity('stop').velocity({
			opacity : 1
		},{
			duration : 500
			complete : ()->
				fire = false
				return
			display  : 'block'
		})
		return
	# --------------------------------------------------------------------------
	# スライドタイマーのセット：サムネイルが溢れていてもいなくても同じ処理
	# --------------------------------------------------------------------------
	setSlideTimer = ()->
		if(slideTimer) then clearTimeout(slideTimer)
		slideTimer = setTimeout(()->
			# 停止状態であれば何もしない
			if forceDisable then return

			$bottomArrow.trigger('click')
			setSlideTimer()
			return
		,autoSlideTime)
		return
	# --------------------------------------------------------------------------
	# スライダーにマウスが乗っている時の処理：スライダーの一時停止と再開
	# --------------------------------------------------------------------------
	$bigSlider.on(
		'mouseenter' : (e)->
			# スライダーの中のクリックがトリガーされても動くので
			$bigSlider.one('mousemove', ()->
				if(slideTimer) then clearTimeout(slideTimer)
				return
			)
			return
		'mouseleave' : (e)->
			$bigSlider.off('mousemove')
			setSlideTimer()
			return
	)
	# --------------------------------------------------------------------------
	# サムネイルが溢れていないときの処理
	# --------------------------------------------------------------------------
	if !thumbnailsOver
		# ----------------------------------------------------------------------
		# 上、下矢印操作
		# ----------------------------------------------------------------------
		arrowClickFunction = (e,target)->
			# スライダー画像変更時は変更禁止
			if fire then return false
			$parent = $activeThumbnail.parent()
			num     = $('li',$thumbSet).index($parent)
			if target == 'top'
				num--
			else if target == 'bottom'
				num++
			if num < 0 then num = thumbNum - 1 else num = num % thumbNum
			$($thumbnail[num]).trigger('mouseover').trigger('click', [true])
			return
		$topArrow.on('click',(e)->
			arrowClickFunction(e, 'top')
			return
		)
		$bottomArrow.on('click',(e)->
			arrowClickFunction(e, 'bottom')
			return
		)
		# ----------------------------------------------------------------------
		# イベント
		# ----------------------------------------------------------------------
		$thumbnail.on(
			# マウスオーバー処理
			'mouseover' : (e)->
				$this = $(this)
				if $this.hasClass('active') then return false
				reg   = /\/*.(jpg|jpeg|gif|png)$/
				rpd   = '--over.$1'
				$this = $(this)
				src   = $this.attr('src').replace(reg,rpd)
				$this.attr('src',src)
				return
			# マウスアウト処理
			'mouseout'  : (e)->
				$this = $(this)
				if $this.hasClass('active') then return false
				reg   = /\/*--over.(jpg|jpeg|gif|png)$/
				rpd   = '.$1'
				$this = $(this)
				src   = $this.attr('src').replace(reg,rpd)
				$this.attr('src',src)
				return
			# クリック時の処理
			'click'     : (e, indirect)->
				# スライダー画像変更時は変更禁止
				if fire then return false
				$this   = $(this)
				$parent = $this.parent()
				if $this.hasClass('active') then return false
				if $activeThumbnail
					$activeThumbnail.removeClass('active')
					$activeThumbnail.trigger('mouseout')

				# クリックされたらスライダーを停止状態にする
				if !indirect then forceDisable = true

				$activeThumbnail = $this
				$activeThumbnail.addClass('active')
				changeImg($activeThumbnail.parent().data('name'))
				setSlideTimer()
				return
		)
		$('li:first-child img',$thumbSet).trigger('mouseover').trigger('click', [true])
		setSlideTimer()
	# --------------------------------------------------------------------------
	# サムネイルが溢れているときの処理
	# --------------------------------------------------------------------------
	if thumbnailsOver
		posOffsetNum  = 0
		posOffsetVal  = 0
		posFirstLi    = false
		posLastLi     = false
		maxPos        = 0
		$thumbnail    = $('li',$thumbSet)
		$thumbnailImg = $('li img',$thumbSet)
		$dummyThumbs  = $thumbnail.clone(true)
		$($thumbnail[0]).addClass('start')
		for i in [0..$dummyThumbs.length - 1]
			preventNum  = ($dummyThumbs.length - 1) - i
			$prependCnt = $dummyThumbs[preventNum]
			$thumbSet.prepend($prependCnt)
		$thumbSet.append($dummyThumbs.clone(true))

		posOffsetNum  = $thumbnail.length
		posOffsetVal  = thumbHeight * posOffsetNum
		$thumbnail    = $('li', $thumbSet)
		$thumbnailImg = $('li img', $thumbSet)
		$thumbSet.css('height', $thumbnail.length * thumbHeight).addClass('over').css('top',posOffsetVal * -1)

		for thumb,i in $thumbnail
			$(thumb).css('top',(i * thumbHeight)).data('pos',i * thumbHeight)
			if i == 0 then posFirstLi = $(thumb)
			if i == $thumbnail.length-1 then posLastLi = $(thumb)

		maxPos = posLastLi.data('pos')

		# ----------------------------------------------------------------------
		# スライド
		# ----------------------------------------------------------------------
		slide = (v,num)->
			d = $.Deferred()
			val  = 0
			switch v
				when 'top'
					val = thumbHeight * num * -1
				when 'bottom'
					val = thumbHeight * num
			$thumbnail.velocity({
				top : '+='+val
			},{
				duration : 200
				complete : (e)->
					slideComplate(e,v,val,d)
					return
			})
			return d.promise()

		slideComplate = (e,v,val,d)->
			for thumb,i in $thumbnail
				pos = $(thumb).data('pos') + val
				$(thumb).data('pos',pos)
			if v == 'top'
				underArr = _.select($thumbnail,(t)->
					$t = $(t)
					return $t.data('pos') <= 0
				)
				for i in [0..underArr.length-1]
					$t  = $(underArr[i])
					if($t.data('pos') == 0)
						posFirstLi = $t
					else
						val = posLastLi.data('pos') + thumbHeight
						$t.css('top',val).data('pos',val)
						posLastLi = $t
			if v == 'bottom'
				overArr = _.select($thumbnail,(t)->
					$t = $(t)
					return $t.data('pos') >= maxPos
				)
				for i in [0..overArr.length-1]
					$t  = $(overArr[i])
					if($t.data('pos') == maxPos)
						posLastLi = $t
					else
						val = posFirstLi.data('pos') - thumbHeight
						$t.css('top',val).data('pos',val)
						posFirstLi = $t
			d.resolve()
			return
		# ----------------------------------------------------------------------
		# 上、下矢印操作
		# ----------------------------------------------------------------------
		# 上矢印
		$topArrow.on('click',(e)->
			if fire then return false
			$prev = $activeThumbnail.prev()
			if $prev.length
				$activeThumbnail.prev().children('img').trigger('click', [true])
			else
				$('li:last-child', $activeThumbnail.parent()).children('img').trigger('click', [true])
			return
		)
		# 下矢印
		$bottomArrow.on('click',(e)->
			if fire then return false
			# $activeThumbnail.next().children('img').trigger('click')
			$next = $activeThumbnail.next()
			if $next.length
				$activeThumbnail.next().children('img').trigger('click', [true])
			else
				$('li:first-child', $activeThumbnail.parent()).children('img').trigger('click', [true])
			return
		)
		# ----------------------------------------------------------------------
		# サムネイルイベント
		# ----------------------------------------------------------------------
		# マウスオーバー
		$thumbnailImg.on(
			'mouseover' : (e)->
				$this = $(this)
				if $this.hasClass('active') then return false
				reg   = /\/*.(jpg|jpeg|gif|png)$/
				rpd   = '--over.$1'
				$this = $(this)
				if /--over/.test($this.attr('src')) then return false
				src   = $this.attr('src').replace(reg,rpd)
				$this.attr('src',src)
				return
			'mouseout'  : (e)->
				$this = $(this)
				if $this.hasClass('active') then return false
				reg   = /\/*--over.(jpg|jpeg|gif|png)$/
				rpd   = '.$1'
				$this = $(this)
				src   = $this.attr('src').replace(reg,rpd)
				$this.attr('src',src)
				return
			'click'     : (e, indirect)->
				## 処理中は動作しない
				if fire then return false
				$this   = $(this)
				# クリックされたらスライダーを停止状態にする
				if !indirect then forceDisable = true

				$parent = $this.parent()
				nowPos  = $activeThumbnail.data('pos')
				newPos  = $parent.data('pos')
				setPos  = (nowPos - newPos)
				if setPos < 0
					v       = 'top'
					setPos *= -1
				else
					v = 'bottom'
				if $activeThumbnail
					$activeThumbnail.children('img').removeClass('active').trigger('mouseout')
				$activeThumbnail = $parent
				$activeThumbnail.children('img').trigger('mouseover').addClass('active')
				fire = true
				slide(v,setPos / thumbHeight).done((e)->
					fire = false
					changeImg($activeThumbnail.data('name'))
					return
				)
				setSlideTimer()
				return
		)
		$activeThumbnail = $('li.start')
		$activeThumbnail.children('img').trigger('mouseover').addClass('active')
		changeImg($activeThumbnail.data('name'))
		setSlideTimer()
	return

# ==============================================================================
# ready..
# ==============================================================================
$(->
	bannerSetting()
	panelSetting()
	bigSliderSetting()
	return
)
